import React from 'react';
import { withTheme } from 'styled-components';
import { Figure } from './Figure.styled';

type ImagePlaceholderProps = {
  theme: { [key: string]: any };
  alt: string;
};
export const ImagePlaceholder = (props: ImagePlaceholderProps) => (
  <Figure
    width="216px"
    height="144px"
    viewBox="0 0 216 144"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    role="img"
    arialabel={props.alt}
  >
    <title>Image placeholder icon</title>
    <desc>Created with sketchtool.</desc>
    <defs>
      <path id="d68k9z9t2a" d="M0 0H216V144H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-432 -931) translate(402 771) translate(30 160)">
            <mask id="zongbsjn4b" fill="#fff">
              <use xlinkHref="#d68k9z9t2a" />
            </mask>
            <use fill="#C3CAD7" opacity=".2" xlinkHref="#d68k9z9t2a" />
            <path
              fill="#42515F"
              d="M119.632 61c.755 0 1.368.613 1.368 1.368v19.264c0 .755-.613 1.368-1.368 1.368H96.368C95.613 83 95 82.387 95 81.632V62.368c0-.755.613-1.368
              1.368-1.368h23.264zM119 63H97v18h22V63zm-8 6c.667 0 2.667 3 6 9H99c2.667-4 4.333-6 5-6 .667 0 1.667 1 3 3 2-4 3.333-6 4-6z"
              mask="url(#zongbsjn4b)"
              opacity=".2"
            />
          </g>
        </g>
      </g>
    </g>
  </Figure>
);

export default withTheme(ImagePlaceholder);
